module.exports = __webpack_public_path__ + "index/img/shangpinxiangqing.7e9e09b9.png";